"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_FIELD_META = void 0;
// Asset / building fields tracked by the Update vs Correction diff. Used by
// the edit dialog and the history timeline so they show the same set of
// fields in the same order.
var ASSET_FIELD_META = [
    { key: "name", label: "Name", group: "Basic" },
    { key: "code", label: "Code", group: "Basic" },
    { key: "type", label: "Type", group: "Basic" },
    { key: "description", label: "Description", group: "Basic" },
    { key: "isActive", label: "Active", group: "Basic" },
    { key: "address", label: "Address", group: "Address" },
    { key: "floors", label: "Floors", group: "Basic" },
    { key: "development", label: "Development", group: "Basic" },
    { key: "billingSettings", label: "Billing Settings", group: "Billing" },
    { key: "isBilledDirectlyByEskom", label: "Billed Directly by Eskom", group: "Billing" },
    { key: "locality", label: "Locality", group: "Supply" },
    { key: "transmissionZone", label: "Transmission Zone", group: "Supply" },
    { key: "voltageLevel", label: "Voltage Level", group: "Supply" },
    { key: "supplySource", label: "Supply Source", group: "Supply" },
    { key: "hasGridTiedGeneration", label: "Grid-Tied Generation", group: "Supply" },
    { key: "nmdKva", label: "NMD (kVA)", group: "Supply" },
    { key: "phases", label: "Phases", group: "Supply" },
    { key: "mainBreakerAPerPhase", label: "Main Breaker (A / phase)", group: "Supply" },
    { key: "tags", label: "Tags", group: "Basic" },
    { key: "gla", label: "GLA", group: "Basic" },
    { key: "lsm", label: "LSM", group: "Basic" },
    // RF-1. lsmValues is derived from lsmRange server-side and deliberately not listed — it would
    // report the same change twice in the history.
    { key: "lsmRange", label: "LSM Bracket", group: "Basic" },
    { key: "landSizeSqm", label: "Asset Land Size (m²)", group: "Basic" },
    { key: "totalBuiltSqm", label: "Total Built (m²)", group: "Basic" },
    { key: "financialIndicators", label: "Financial Indicators", group: "Basic" },
    { key: "location", label: "Location", group: "Address" },
    { key: "areaCodeSuffixDigits", label: "Area Code Suffix Digits", group: "Basic" },
    { key: "owner", label: "Owner", group: "Owner" },
    { key: "assetManagerId", label: "Asset Manager", group: "Management" },
    { key: "utilitiesManagerId", label: "Utilities Manager", group: "Management" },
    { key: "buildingAccountantId", label: "Building Accountant", group: "Management" },
    { key: "leasingManagerId", label: "Leasing Manager", group: "Management" },
    { key: "operationsManagerId", label: "Operations Manager", group: "Management" },
    { key: "buildingManagerId", label: "Building Manager", group: "Management" },
];
exports.ASSET_FIELD_META = ASSET_FIELD_META;
